<template>
  <fragment>
    <div class="card-on-card card-outline-secondary">
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold"><b> Spesifikasi</b></h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name"
                >Barang Asal</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookOrigin"
                  id="nonBookOrigin"
                >
                  <option value="Dalam Negeri">Dalam Negeri</option>
                  <option value="Luar Negeri">Luar Negeri</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Processor</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookProcessor"
                  id="nonBookProcessor"
                >
                  <option value="Intel Core i5">Intel Core i3</option>
                  <option value="Intel Core i5">Intel Core i5</option>
                  <option value="Intel Core i5">Intel Core i7</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name"
                >Barang Produsen</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookProducer"
                  id="nonBookProducer"
                >
                  <option value="UMKM">UMKM</option>
                  <option value="Non UMKM">Non UMKM</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Memory / RAM</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookMemoryRam"
                  id="nonBookMemoryRam"
                >
                  <option value="4GB">4GB</option>
                  <option value="8GB">8GB</option>
                  <option value="16GB">16GB</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name">Kondisi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookCondition"
                  id="nonBookCondition"
                >
                  <option value="Baru">Baru</option>
                  <option value="Bekas">Bekas</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>

              <label class="col-md col-form-label" for="name">Hard Disk</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookHarddisk"
                  id="nonBookHarddisk"
                >
                  <option value="HDD500GB">HDD 500GB</option>
                  <option value="HDD1TB">HDD1TB</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Stok</label>
              <div class="col-lg-4">
                <CurrencyInput
                  max="999999999999"
                  maxlength="20"
                  oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                              this.value=(this.value   < 0) ? (1/1) : this.value;"
                  v-model="stock"
                  @keyup="validateNotNull('nonBookStock')"
                  name="bookStock"
                  class="form-control"
                  id="nonBookStock"
                />
                <div class="invalid-feedback invalidStock"></div>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">DVD/CD</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookDvd"
                  id="nonBookDvd"
                >
                  <option value="DVD">DVD</option>
                  <option value="CD">CD</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Garansi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookWarranty"
                  id="nonBookWarranty"
                >
                  <option value="GaransiToko">GaransiToko</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md-2 col-form-label" for="name">Monitor</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookMonitor"
                  id="nonBookMonitor"
                >
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Berat (Kg)</label>
              <div class="col-lg-4">

                <input
                  type="number"
                  name="nonBookWeight"
                  id="nonBookWeight"
                  class="form-control"
                  placeholder="0"
                  @keyup="validateNotNullWeight('nonBookWeight')"
                  step="0.1"
                  value="0.2"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                />
                <span class="invalid-feedback"
                  >Tidak boleh kosong / angka 0</span
                >
                <span class="small text-muted"
                  >Gunakan tanda . untuk menuliskan titik (misal: 0.200)</span
                >
              </div>
              <label class="col-md col-form-label" for="name">OS</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookOs"
                  id="nonBookOs"
                >
                  <option value="DOS">DOS</option>
                  <option value="Windows">Windows</option>
                  <option value="Linux">Linux</option>
                  <option value="Macos">Mac Os</option>
                  <option value="Android">Android</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Dimensi</label>
              <div class="col-md-4">
                <div class="input-group mb-3">
                  <span class="input-group-text">P</span>
                  <input
                    type="number"
                    name="nonBookLength"
                    step="0.1
                    "
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    id="nonBookLength"
                    class="form-control"
                    placeholder="0"
                    value="0"
                    aria-label="Username"
                  />
                  <span class="input-group-text">L</span>
                  <input
                    step="0.1
                    "
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    type="number"
                    name="nonBookWidth"
                    id="nonBookWidth"
                    class="form-control"
                    placeholder="0"
                    value="0"
                    aria-label="Server"
                  />
                  <span class="input-group-text">T</span>
                  <input
                    step="0.1
                    "
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    type="number"
                    name="nonBookHeight"
                    id="nonBookHeight"
                    class="form-control"
                    value="0"
                    placeholder="0"
                    aria-label="Server"
                  />
                </div>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Aplikasi Terpasang
              </label>
              <div class="col-lg-4">
                <input
                  class="form-control"
                  type="text"
                  name="nonBookApplication"
                  id="nonBookApplication"
                  placeholder="contoh: Ms.Office, Adobe CS, AntiVirus"
                />
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Status</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookActiveStatus"
                  id="nonBookActiveStatus"
                >
                  <option value="1">Enable (Aktif)</option>
                  <option value="0">Disable (Tidak Aktif)</option>
                </select>
                <p class="text-muted small">
                  Gunakan tanda '.' untuk menuliskan koma (misal: 0.200)
                </p>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Tipe Produk</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="nonBookAvailability"
                  id="nonBookAvailability"
                >
                  <option value="Ready Stock">Ready Stock</option>
                  <option value="PreOrder">PreOrder</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
// import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      stock: 0,
    };
  },
  methods: {
    validateNotNullWeight(idEl) {
      let element = $(`#${idEl}`);

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else if (element.val() == 0 && element.val() !== "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
    validateNotNull(idEl) {
      let element = $(`#${idEl}`);

      if (element.val().includes("-")) {
        $(`#${idEl}`).val(0);
      }

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
  },
  watch: {
    stock() {
      if (this.stock === null) {
        $(".invalidStock").text(`Stok tidak boleh kosong`);
        $("#nonBookStock").addClass("is-invalid");
      } else {
        $("#nonBookStock").removeClass("is-invalid");
      }
    },
  },
};
</script>